module.exports = __webpack_public_path__ + "img/mood.1da1ddbb.png";